import { api } from '@/utils/api';
import { ProfileUser, UpdateProfileDto, UserAccount } from './types';

export const getUserProfile = async (): Promise<ProfileUser> => {
  return (await api.get('/users/me')).data.data;
};

export const updateUserProfile = async (userData: UpdateProfileDto): Promise<ProfileUser> => {
  return (await api.patch('/users/me', userData)).data;
};

/** RC10: "Follow the new proposal flow for new proposals" (PATCH /users/me with only this field). */
export const updateProposalFlowPreference = async (useNewProposalFlow: boolean): Promise<ProfileUser> => {
  return (await api.patch('/users/me', { useNewProposalFlow })).data.data;
};

export const changeProfilePassword = async (password: string): Promise<void> => {
  return (await api.post('/users/me/change-password', { password })).data;
};

export const getUserLoggedInAccounts = async (): Promise<UserAccount[]> => {
  return (await api.get('/users/accounts')).data?.data?.accounts || [];
};
